import { __decorate, __metadata } from "tslib";
import { MEDIA_PROPS_ACCESSOR, MEDIA_PROPS_EDITORDEF, MediaAssets } from '@common/media/shared';
import { UseRestraints } from '@core/shared/restraints';
import { CrudEndpoints, Default, EditorDefinition, Expose, IdItemModel, ItemModelDefinition, MinLength, Trim, ModelId } from '@core/shared/model';
import { QuestionAttachmentRestraints } from './question-attachment.restraints';
let QuestionAttachmentItem = /*#__PURE__*/(() => {
  let QuestionAttachmentItem = class QuestionAttachmentItem extends IdItemModel {};
  __decorate([Expose(), Trim(), MinLength(3), Default(''), __metadata("design:type", String)], QuestionAttachmentItem.prototype, "name", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], QuestionAttachmentItem.prototype, "questionCategoryId", void 0);
  QuestionAttachmentItem = __decorate([EditorDefinition('admin', {
    name: true,
    [MEDIA_PROPS_ACCESSOR]: MEDIA_PROPS_EDITORDEF
  }), CrudEndpoints({
    admin: '/admin/questions/categories/:questionCategoryId/attachments'
  }), UseRestraints(QuestionAttachmentRestraints), ItemModelDefinition({
    texts: {
      item: 'Anhang',
      items: 'Anhänge',
      newItem: 'Neuen Anhang erstellen'
    }
  }), MediaAssets(['file']), ModelId("QuestionAttachmentItem") // auto-generated by generate-model-ids
  ], QuestionAttachmentItem);
  return QuestionAttachmentItem;
})();
export { QuestionAttachmentItem };